<template>
  <div class="login">
    <div class="login-pos">
        <div class="login-box">
          <div class="login-box-cbox" v-if="islogin">
            <h2>欢迎您使用<br/>佳洪后台管理系统</h2>
            <div class="inputbox">
              <input type="text" class="inputlength" v-model="useraccount"  ref="inputa"  placeholder="请输入您的账号"/>
            </div>
            <div class="inputbox">
              <input :type="apasstype?'password':'text'" class="inputlength" v-model="userpassword"  ref="inputb"  placeholder="请输入密码"/>
              <span :class="apasstype?'eyeview':'openeye'" @click="typeset(1)"></span>
            </div>
            <!--
            <div class="inputbox verification">
              <input type="text" class="inputlength" v-model="usercode"  ref="inputc"  placeholder="请输入右侧验证码"/>
              <img :src="authenticationcode" @click="provingcode()"/>
            </div>-->
            <div class="btn-blue" @click="into()">
              马上登录
            </div>
            <!-- <div class="input-tips-wrap">
              <div class="radio fl " @click="agreeserver()"><span :class="{'on':isagree}"></span>记住用户名</div>
              <span class="fr findpassword" @click="findpassword()">忘记密码</span>
            </div> -->
          </div>
          <div class="login-box-cbox" v-if="!islogin">
            <div class="backoff" title="返回登录" alt='返回登录' @click="tologin()"></div>
            <h2>密码找回</h2>
            <div class="inputbox">
              <input type="text" class="inputlength" v-model="useraccount"  ref="inputd"  placeholder="请输入您的账号"/>
            </div>
            <div class="inputbox">
              <input type="text" class="inputlength" v-model="telphonenumber"  ref="inpute"  placeholder="请输入手机号码"/>
            </div>
            <div class="inputbox verification">
              <input type="text" class="inputlength" v-model="phonesmscode"  ref="inputf"  placeholder="请输入手机验证码"/>
              <div class="phonecode">
                <span  v-if="timeshow" @click="sendsms()">获取验证码</span>
                <span v-else-if="!timeshow" class="count">{{count}} s</span>
              </div>
            </div><span class="sendtips">已发送，请注意查收</span>
            <div class="inputbox">
              <input :type="bpasstype?'password':'text'" class="inputlength" v-model="newpassword"  ref="inputg"  placeholder="请输入新密码"/>
              <span :class="bpasstype?'eyeview':'openeye'" @click="typeset(2)"></span>
            </div>
            <div class="inputbox">
              <input :type="cpasstype?'password':'text'" class="inputlength" v-model="twopassword"  ref="inputh"  placeholder="请确认新密码"/>
              <span :class="cpasstype?'eyeview':'openeye'" @click="typeset(3)"></span>
            </div>
            <div class="btn-blue" @click="passwordchange()">
              修改密码
            </div>
          </div>
          <!--<div class="bottom_login">没有帐号？立即<span>注册</span></div>-->
        </div>
      </div>
        <!-- <div class="footer">
      <div class="conter cbox foot-ptop">
        <div class="enterprise">联系我们</div>
        <div class="located">
          <ul class="boxone fl">
            <li >联系地址：浙江省杭州市西湖区西溪世纪中心2栋732室</li>
            <li>联系电话：<span class="tel-phone">0571-28874093</span></li>
          </ul>
          <ul class="boxtwo fl">
            <li>商务合作：bd@borntrust.com</li>
            <li>联系邮箱：service@borntrust.com</li>
            <li>简历投递：hr@borntrust.com</li>
          </ul>
        </div> 
      </div>
      <div class="copyright">
        <span>杭州柏安金融信息咨询有限公司 版权所有 浙ICP备14039650 浙公网安备 33011002011487号</span>
      </div>
    </div>-->
  </div> 
</template>
<script>
import Headbar from '@/components/headbar'
export default {
    components: {
    Headbar
  },
  data () {
    return {
      isagree:false,
      authenticationcode:"",
      useraccount:"",
      userpassword:"",
      usercode:"",
      apasstype:true,
      bpasstype:true,
      cpasstype:true,
      yzcode:"",
      islogin:true,
      timeshow:true,
      timecount: 120,
      count:0,
      telphonenumber:'',
      phonesmscode:'',
      newpassword:'',
      twopassword:''
    }
  },
  methods: {
    into(){
      let m =this
      if(this.useraccount==""){
        alert("请输入登录账号");
        return
      }
      else if(this.userpassword==""){
        alert("请填写登录密码");
        return
      }
      else{
        // this.ajax.post("http://47.99.157.156:33100/auth/login",{bizContent:{mobile:this.useraccount,cid:this.userpassword}} ).then(
           this.ajax.post("https://api.andarm.com.cn/auth/oalogin",{bizContent:{mobile:this.useraccount,cid:this.userpassword}} ).then(
          response=> {
            if(response.data.status=="0000"){
              var token=response.data.data
              console.log(token);
              var u=this.useraccount
              this.$store.commit('set_token', token)
              this.$store.commit('set_user', u)
              // this.$store.commit('set_userid', u)
              this.$router.push({ name: 'Control'})
            }
            else{
              swal({
                text: response.data.message,
                timer: 3000,
                buttons: false
              })
            }
            
          }
        )
      }
    },
    typeset(){
      this.apasstype=!this.apasstype
    }
  }
}
</script>

<style>
.login{
  width:100%;
  height:100%;
  min-height:100vh;
  background: url('../assets/loginbg.jpg') center top no-repeat;
  padding-top:21px;
}
.login-pos{
  width:100%;
  height:511px;
  margin:234px auto;
}
.login-box{
width:577px;
  min-height:511px;
  background:rgba(255,255,255,1);
  border-radius:1px;
  position: absolute;
  left:50%;
  top:186px;
  margin-left:-288px;
}
.login-box h2{
  height:72px;
  font-size:24px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(33,33,33,1);
  line-height:38px;
  margin-bottom: 4px;
  text-align: center
}
.login-box-cbox{
  width:400px;
  margin:54px auto;
}
.inputbox{
  width:100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  position: relative;
  background: #fff;
  border:1px solid rgba(227,228,229,1);
  border-radius:2px;
  margin-top:30px;
}
.inputbox input{
  width:100%;
  background: none;
  border:none;
  height: 40px;
  line-height: 40px;
  text-indent: 16px;
  border-radius:2px;
  box-shadow:0px 0px 2px 0px transparent;
}
.inputbox.verification input{
  width:70%;
  float: left;
  background: none;
  border:none;
  height: 40px;
  line-height: 40px;
  text-indent: 16px;
  border-radius:2px;
  box-shadow:0px 0px 2px 0px transparent;
}
.inputbox.verification img{
  float: right;
}
.inputbox input:focus{
  background:rgba(255,255,255,1);
  border-radius:2px;
  border:1px solid #4AAFE9;
  margin-top:-1px;
  margin-left: -1px;
}
.inputbox.code input:focus{
  border-right:none;
}
.btn-blue{
  width:100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  color:#fff;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.5);
  border-radius:2px;
  margin-top:28px;
  cursor: pointer;
}
.input-tips-wrap{
  width:100%;
  margin-top:30px;
  height:20px;
  font-size: 14px;
}
.findpassword{
  color:rgba(102,102,102,1);
  cursor: pointer;
}
.findpassword:hover{
  color: #333
}
.bottom_login{
  width:99%;
  position:absolute;
  left: 0;
  bottom: 0;
  width:575px;
  height:65px;
  line-height: 65px;
  background:rgba(246,246,246,1);
  border:1px solid rgba(235,235,235,1);
  font-size:20px;
  color:rgba(102,102,102,1);
  cursor: pointer;
  text-align: center;
  font-weight: bold;
}
.bottom_login span{
color: #3D8FE2;
}
.eyeview, .openeye {
    position: absolute;
    right:16px;
    top:0; 
    cursor: pointer;
}
.eyeview:hover:before, .openeye:hover:before {
    color: #333;
}
.eyeview:before, .openeye:before {
  font-family: iconfont!important;
  font-size: 18px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  color: #ccc;
  margin-left: 2px;
  cursor: pointer;

}
.eyeview:before {
  content: "\E6E3";
}
.openeye:before {
  content: "\E6E0";
}
.mh{max-height: 1073px;}
.phonecode{
  width:110px;
  height:40px;
  float: right;
  display: table;
  color: #06f;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.backoff{
  width:40px;
  height:40px;
  position: absolute;
  right:0;
  top:0;
  background: url('../assets/sprite_login.png') center no-repeat;
  cursor: pointer;
}
.sendtips{
    position: absolute;
    display: block;
    left: 88px;
    top: 306px;
    font-size: 12px;
    color: #63BD20;
    background: url('../assets/upload.png') left 0 no-repeat;
    padding-left:22px;
}
.footer{
  width:100%;
  height:165px;
  background: #fff;
  font-size: 14px;
}
.located{
  width:100%;
}
.boxone{width:360px;margin-right:63px;}
.boxtwo{width:777px;}
.boxtwo li{
  float: left;
  margin-right:70px;
}
.boxtwo li:last-child{
  margin-right: 0;
}
.enterprise{
  width:100%;
  height:41px;
  font-size:20px;
  color:rgba(34,34,34,1);
  line-height:28px;
  letter-spacing:1px;
  border-bottom: 1px solid #ccc;
  margin-bottom:35px;
}
.tel-phone{
  font-size:20px;
}
.copyright{
  display: table; 
  clear: both;
  width: 100%;
  height:20px;
  padding: 53px 0 27px 0;
  background:rgba(242,243,244,1);
  background-size: 120px 16px;
  text-align: center;
}
.copyright span{
  color:rgba(102,102,102,1);
  line-height:20px;
  font-size: 14px;
  text-align: center;
}
.foot-ptop{
  display: table;
  height:165px;
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue